import React from "react";
import querystring from "query-string";
import smallBlue from "../../assets/smallBlue.png";

const Login = props => {
  const { user } = props.redux;

  if (user.validated) {
    props.history.push("/");
  }

  let urlParams = {
    client_id: process.env.REACT_APP_OKTA_CLIENT_ID,
    response_type: "code",
    scope: "openid",
    redirect_uri: `${window.location.protocol}${process.env.REACT_APP_URL}/implicit/callback`,
    state: "state",
    code_challenge_method: "s256",
    code_challenge: "qjrzSW9gMiUgpUvqgEPE4_-8swvyCtfOVvg55o5S_es"
  };

  urlParams = querystring.stringify(urlParams);
  const route = `${process.env.REACT_APP_OKTA_ORG_URL}/oauth2/v1/authorize?${urlParams}`;

  const parsed = querystring.parse(window.location.search.substring(1));

  if (parsed.autoLogin === "1") {
    window.location.replace(route);
  }

  return (
    <div className="loginContainer">
      <div className="loginContent">
        <div>
          <img src={smallBlue} alt="EF Logo" />
        </div>
        <div className="Top">
          <h1>
            <strong>Equipment Finder</strong>
          </h1>
        </div>
        <div className="Center">
          <a className="loginButton" href={route}>
            <div className="Center login">
              <label>Login</label>
            </div>
          </a>
        </div>
        <div className="Bottom">
          <a href="https://rainforrent.okta.com/help/login" target="_blank">
            Help
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
